
export default {
  name: 'icon-calendar',
};
